import type { Dispatch, SetStateAction } from 'react';
import { useCallback, useState } from 'react';

/* Same as useState, except 3 return-value allow for partial state updates */
function ReactUseStateWithUpdate<S>(
    initialState: S | (() => S),
): [S, Dispatch<SetStateAction<S>>, Dispatch<Partial<S>>] {
    const [getVal, setVal] = useState<S>(initialState);
    const updateVal = useCallback((partial: Partial<S>) => {
        setVal(sPrev => ({ ...sPrev, ...partial }));
    }, []);
    return [getVal, setVal, updateVal];
}

export default ReactUseStateWithUpdate;
